module.exports = __webpack_public_path__ + "img/pasture_cynodon_low.7f68826c.jpg";